import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { message } from 'antd';
import { ConfigProvider } from 'antd';
import zh_CN from 'antd/es/locale/zh_CN';

message.config({ top: 100, duration:2, maxCount:1 })


ReactDOM.render(


<ConfigProvider locale={zh_CN}>
    <App />
  </ConfigProvider>,
  document.getElementById('root')

  // // <React.StrictMode>
  //   <App />,
  // // </React.StrictMode>,
  // document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
